export const variantClasses = {
    solid: {
        accent: 'bg-accent-500 text-white',
        info: 'bg-info-600 text-white',
        success: 'bg-success-600 text-white',
        warning: 'bg-warning-500 text-white',
        danger: 'bg-danger-600 text-white',
        primary: 'bg-slate-950 dark:bg-white text-white dark:text-slate-950',
        secondary: 'bg-slate-600 text-white',
        tertiary: 'bg-slate-500 text-white',
        quaternary: 'bg-slate-400 text-white',
        black: 'bg-black text-white',
        white: 'bg-white text-black',
        none: '',
    },
    soft: {
        accent: 'bg-accent-100 dark:bg-accent-900 text-accent-600 dark:text-accent-200',
        info: 'bg-info-100 dark:bg-info-900 text-info-600',
        success: 'bg-success-100 dark:bg-success-900 text-success-600',
        warning: 'bg-warning-100 dark:bg-warning-900 text-warning-600',
        danger: 'bg-danger-100 dark:bg-danger-900 text-danger-600',
        primary: 'bg-slate-100 dark:bg-white text-slate-900 dark:text-slate-950',
        secondary: 'bg-slate-50 dark:bg-slate-950 text-slate-600',
        tertiary: 'bg-slate-50 dark:bg-slate-500/20 text-slate-500',
        quaternary: 'bg-slate-50 dark:bg-slate-400/20 text-slate-400',
        black: 'bg-black/10 text-black',
        white: 'bg-white/10 text-white',
        none: '',
    },
    outline: {
        accent: 'border border-accent-500 text-accent-500',
        info: 'border border-info-600 text-info-600',
        success: 'border border-success-600 text-success-600',
        warning: 'border border-warning-500 text-warning-500',
        danger: 'border border-danger-600 text-danger-600',
        primary: 'border border-slate-950 dark:border-white text-slate-950 dark:text-white',
        secondary: 'border border-slate-600 text-slate-600',
        tertiary: 'border border-slate-500 text-slate-500',
        quaternary: 'border border-slate-400 text-slate-400',
        black: 'border border-black text-black',
        white: 'border border-white text-white',
        none: '',
    },
    ghost: {
        accent: 'text-accent-500 dark:text-accent-500',
        info: 'text-info-600 dark:text-info-500',
        warning: 'text-warning-500 dark:text-warning-600',
        success: 'text-success-600 dark:text-success-700',
        danger: 'text-danger-600 dark:text-danger-700',
        primary: 'text-slate-900 dark:text-neutral-50',
        secondary: 'text-slate-600 dark:text-neutral-400',
        tertiary: 'text-slate-500 dark:text-neutral-500',
        quaternary: 'text-slate-400 dark:text-neutral-600',
        white: 'text-white',
        black: 'text-black',
        none: '',
    },
    link: {
        accent: 'text-accent-500 dark:text-accent-500',
        info: 'text-info-600 dark:text-info-500',
        warning: 'text-warning-500 dark:text-warning-600',
        success: 'text-success-600 dark:text-success-700',
        danger: 'text-danger-600 dark:text-danger-700',
        primary: 'text-slate-900 dark:text-neutral-50',
        secondary: 'text-slate-600 dark:text-neutral-400',
        tertiary: 'text-slate-500 dark:text-neutral-500',
        quaternary: 'text-slate-400 dark:text-neutral-600',
        white: 'text-white',
        black: 'text-black',
        none: '',
    },
};
